/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/TimelineEvent/FutureSeparator/Actions/AddAppointment/Add/Content/AppointmentTypes/Loading"
  
}) {
  return null
}